(function () {
  'use strict';

  function initStickyBar() {
    var sticky = document.querySelector('[data-devora-pdp-sticky]');
    var gallery = document.querySelector('[data-product-gallery-viewport]');
    var mainSubmit = document.querySelector('[data-product-submit]');
    var stickyBtn = document.querySelector('[data-devora-sticky-atc]');
    var stickyPrice = document.querySelector('[data-devora-sticky-price]');
    var mainPrice = document.querySelector('.product__price .money--last');

    if (!sticky || !gallery) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0] && entries[0].isIntersecting;
        sticky.hidden = visible;
        sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
        document.body.classList.toggle('devora-pdp-sticky-active', !visible);
      },
      { threshold: 0, rootMargin: '0px 0px -1px 0px' }
    );
    observer.observe(gallery);

    if (stickyBtn && mainSubmit) {
      stickyBtn.addEventListener('click', function () {
        if (!mainSubmit.disabled) mainSubmit.click();
      });
    }

    function syncPrice() {
      if (stickyPrice && mainPrice) stickyPrice.textContent = mainPrice.textContent;
      if (stickyBtn && mainSubmit) stickyBtn.disabled = mainSubmit.disabled;
    }

    syncPrice();
    document.addEventListener('change', function (e) {
      if (
        e.target &&
        (e.target.matches('.single-option-selector') ||
          e.target.matches('[data-variants]') ||
          e.target.closest('[data-product-form]'))
      ) {
        window.setTimeout(syncPrice, 100);
      }
    });
    var priceWrap = document.querySelector('.product__price');
    if (priceWrap && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceWrap, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  function initRecoCarousel(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-devora-reco-carousel]');
    carousels.forEach(function (carousel) {
      if (carousel.getAttribute('data-devora-reco-ready') === '1') return;
      var track = carousel.querySelector('[data-devora-reco-track]');
      if (!track) return;
      carousel.setAttribute('data-devora-reco-ready', '1');
      var prev = carousel.querySelector('[data-devora-reco-prev]');
      var next = carousel.querySelector('[data-devora-reco-next]');
      function scrollByDir(dir) {
        var card = track.querySelector('.product');
        var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });
    });
  }

  function initQtySteppers() {
    document.querySelectorAll('[data-devora-qty]').forEach(function (wrap) {
      if (wrap.getAttribute('data-devora-qty-ready') === '1') return;
      var input = wrap.querySelector('.product-quantity-input');
      var minus = wrap.querySelector('[data-devora-qty-minus]');
      var plus = wrap.querySelector('[data-devora-qty-plus]');
      if (!input || !minus || !plus) return;
      wrap.setAttribute('data-devora-qty-ready', '1');

      function step(delta) {
        var min = parseInt(input.getAttribute('min'), 10);
        if (isNaN(min)) min = 1;
        var next = parseInt(input.value, 10);
        if (isNaN(next)) next = min;
        next = Math.max(min, next + delta);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function () { step(-1); });
      plus.addEventListener('click', function () { step(1); });
    });
  }

  function watchRecoCarousel() {
    initRecoCarousel(document);
    var host = document.querySelector('[data-product-recommendations]');
    if (!host || !window.MutationObserver) return;
    new MutationObserver(function () {
      host.querySelectorAll('[data-devora-reco-carousel]').forEach(function (el) {
        el.removeAttribute('data-devora-reco-ready');
      });
      initRecoCarousel(host);
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyBar();
      initQtySteppers();
      watchRecoCarousel();
    });
  } else {
    initStickyBar();
    initQtySteppers();
    watchRecoCarousel();
  }
})();
